import Vue from "vue";

Vue.filter("dateFormat", function(value) {
  if (!value) return "N/A";
  let current_datetime = new Date(value);
  return (
    current_datetime.getDate() +
    "/" +
    (current_datetime.getMonth() + 1) +
    "/" +
    current_datetime.getFullYear() +
    " - " +
    current_datetime.getHours() +
    ":" +
    (current_datetime.getMinutes() < 10 ? "0" : "") +
    current_datetime.getMinutes()
  );
});

Vue.filter("byteToKB", (value) => {
  if (value == 0) {
    return "0 KB";
  }

  if (!value) {
    return "N/A";
  } else {
    let size_in_bytes = value;
    return (size_in_bytes / 1024).toFixed(2) + " KB";
  }
});

Vue.filter("parseBool", (value) => {
  if (value === false || value == 'false') {
    return false;
  } else if (value === true || value == 'true') {
    return true;
  } else {
    return null;
  }
});

Vue.filter("bytesFormat", (value) => { // TODO: remove byteToKB
  if (!value) {
    return "-";
  } else {
    return FormatBytes(value);
  }
})

function FormatBytes(bytes) {
  const KB = 1024;
  const MB = 1048576;
  const GB = 1073741824;
  const TB = 1099511627776;
  const PB = 1125899906842624;

  const FIX_TO = 2;
  if (bytes < KB) {
    return `${bytes}B`;
  } else if (bytes >= KB && bytes < MB) {
    return `${(bytes / KB).toFixed(FIX_TO)}KB`;
  } else if (bytes >= MB && bytes < GB) {
    return `${(bytes / MB).toFixed(FIX_TO)}MB`;
  } else if (bytes >= GB && bytes < TB) {
    return `${(bytes / GB).toFixed(FIX_TO)}GB`;
  } else if (bytes >= TB && bytes < PB) {
    return `${(bytes / TB).toFixed(FIX_TO)}TB`;
  } else {
    return `${(bytes / PB).toFixed(FIX_TO)}PB`;
  }
}